import { Link, Text, useModal, Button, Typography } from "@xcorejs/ui";
import SmartLink, { SmartLinkProps } from "components/SmartLink";
import { UserLoginModal } from "components/User/UserLoginModal";
import { useLayout } from "xcore";
import { SmartLink as SmartLinkType, UserLogin } from "xcore/types";

export type UserLoginSmartLinkType = SmartLinkType | Pick<UserLogin<"userLoginHeading">, "type" | "title" | "values">;

interface UserLoginSmartLinkProps extends Omit<SmartLinkProps, "smartLink"> {
  smartLink: UserLoginSmartLinkType;
  userLoginAsButton?: boolean;
  withoutHighlight?: boolean; // If true, do not show red line on hover
  collapsableSubheaderItemLink?: boolean;
}

const UserLoginSmartLink = ({
  smartLink,
  userLoginAsButton,
  withoutHighlight,
  collapsableSubheaderItemLink,
  ...props
}: UserLoginSmartLinkProps) => {
  const [openUserLoginModal] = useModal(UserLoginModal, { smartLink });
  const { localize, stringify } = useLayout();

  if (!smartLink.values) {
    return null;
  }

  const userLoginHeading = smartLink.type === "userLogin" ? localize(smartLink.values.userLoginHeading) : null;

  return smartLink.type === "userLogin" ? (
    userLoginAsButton ? (
      <Button
        s="sm"
        onClick={openUserLoginModal}
        fontSize="1.4rem"
        lineHeight="2.1rem"
        height="4.6rem"
        textTransform="none"
        fontWeight={600}
        width={{ _: "100%", md: "auto" }}
        justifyContent={{ _: "center", md: "normal" }}
      >
        <Typography color="#ffffff">{userLoginHeading ?? stringify(smartLink.title)}</Typography>
      </Button>
    ) : (
      <Link as="span" type="simple" onClick={openUserLoginModal} role="group" {...props._link}>
        <Text {...props._text}>{userLoginHeading ?? stringify(smartLink.title)}</Text>
      </Link>
    )
  ) : (
    <SmartLink
      smartLink={smartLink}
      {...props}
      withoutHighlight={withoutHighlight}
      collapsableSubheaderItemLink={collapsableSubheaderItemLink}
    />
  );
};

export default UserLoginSmartLink;
